/* global $:false */

import 'modernizr.js'
import Drift from 'drift-zoom/src/js/Drift.js'
import 'spritespin.js'

export default class CommonLotShowGalleryImage {
  static init () {
    Array.from($('.js-common-lot-show-carousel-image')).map((el) =>
      new CommonLotShowGalleryImage(el))
  }

  constructor (el) {
    this.el = $(el)
    this.findElements()
    this.readDataAttributes()
    this.start()
  }

  findElements () {
    this.zoomContainer = $('.js-common-lot-show-zoom-container')
  }

  readDataAttributes () {
    this.threesixtyUrlPattern = this.el.data('threesixty-url-pattern')
  }

  start () {
    if (this.threesixtyUrlPattern) {
      this.replaceWithThreesixty()
    } else {
      this.setupHoverPreview()
    }
  }

  setupHoverPreview () {
    if (window.Modernizr.touchevents) { return }
    return new Drift(
      this.el[0], {
        namespace: 'c-live-lot-show-lot__drift',
        zoomFactor: 8,
        paneContainer: this.zoomContainer[0],
        inlinePane: false,
        injectBaseStyles: false
      }
    )
  }

  replaceWithThreesixty () {
    const template = $('<div class="c-common-lot-show-carousel__link c-common-lot-show-carousel__link--threesixty">')
    template.insertBefore(this.el.parent())
    this.el.parent().remove()

    template.spritespin({
      source: this.threesixtyImages(),
      frameTime: 65,
      width: 512,
      height: 512,
      responsive: true,
      sense: -1,
      behavior: 'drag-animate-on-release'
    })
  }

  threesixtyImages () {
    return window.SpriteSpin.sourceArray(
      this.threesixtyUrlPattern, {
        frame: [1, 80],
        digits: 2
      }
    )
  }
}

function dragEnd (e, data) {
  if (data.dragging) {
    data.dragging = false
    data.animate = true

    window.SpriteSpin.setAnimation(data)
  }
}

window.SpriteSpin.registerModule('drag-animate-on-release', {
  mousedown: window.SpriteSpin.mods.drag.mousedown,
  mousemove: window.SpriteSpin.mods.drag.mousemove,
  mouseup: dragEnd,
  documentmousemove: window.SpriteSpin.mods.drag.documentmousemove,
  documentmouseup: dragEnd,
  touchstart: window.SpriteSpin.mods.drag.touchstart,
  touchmove: window.SpriteSpin.mods.drag.touchmove,
  touchend: dragEnd,
  touchcancel: dragEnd
})
